// Shared "currently viewed week" so the Meal Plan and Shopping List routes stay on the
// same week as the user moves between them (previously free because ShoppingList rendered
// inside MealPlan and received its week as a prop). Stored as a whole-week offset from the
// current week — dow-independent, so it survives week-start changes.
//
// Held in a module-level variable (NOT storage) on purpose: it survives route navigation
// within a session but resets to the current week on a full page reload. Clamped to a
// 2-week past floor to match the navigation UI.
const PAST_FLOOR = -2;
let viewWeekOffset = null;

// Returns the current offset (integer weeks from the current week), or null if unset.
export const readViewWeekOffset = () =>
  Number.isInteger(viewWeekOffset) ? Math.max(PAST_FLOOR, viewWeekOffset) : null;

export const writeViewWeekOffset = (offset) => {
  if (Number.isInteger(offset)) viewWeekOffset = offset;
};
